<section hlmCard>
  <div hlmCardHeader>
    <h2 hlmCardTitle class="font-mono">{{ code() }}</h2>
    @if (subtitle()) {
      <p hlmCardDescription>{{ subtitle() }}</p>
    }
    <div hlmCardAction>
      <span hlmBadge [variant]="badge().variant">
        <ng-icon [name]="badge().icon" />
        {{ badge().label }}
      </span>
    </div>
  </div>

  <div hlmCardContent class="space-y-4">
    <div class="text-center">
      <p hlmMuted class="text-xs">Aktuelles Guthaben</p>
      <p class="text-4xl font-semibold tabular-nums">{{ money(amount()) }}</p>
    </div>

    <div hlmSeparator></div>

    <dl class="grid grid-cols-2 gap-4 text-center">
      <div>
        <dt hlmMuted class="text-xs">Ursprünglicher Wert</dt>
        <dd class="text-base font-medium tabular-nums">{{ money(initialAmount()) }}</dd>
      </div>
      <div>
        <dt hlmMuted class="text-xs">Bereits eingelöst</dt>
        <dd class="text-base font-medium tabular-nums">
          {{ money(initialAmount() - amount()) }}
        </dd>
      </div>
    </dl>

    @if (product(); as product) {
      <div hlmItem variant="outline">
        @if (productImageUrl()) {
          <div hlmItemMedia variant="image">
            <img [src]="productImageUrl()" [alt]="product.name" />
          </div>
        }
        <div hlmItemContent>
          <span hlmItemTitle>{{ product.name }}</span>
          @if (product.description) {
            <span hlmItemDescription>{{ product.description }}</span>
          }
        </div>
      </div>
    }

    <ng-content />
  </div>
</section>
